module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-attachment/bc-e-attachment.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-attachment/bc-e-attachment.component.scss
// module chunks = main